import SearchPage from './SearchPage'

export default SearchPage
// eslint-disable-next-line import/export
export * from './SearchPage'
